import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

export function DownloadIcon({ sx, ...props }: { sx?: SxProps }) {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={{ color: '#55A6FF', ...sx }} {...props}>
      <path
        d="M21 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 1 0-2 0v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1Zm-9.71 1.71c.1.1.2.16.33.21a.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1 1 0 1 0-1.42-1.42L13 12.59V3a1 1 0 0 0-2 0v9.59l-2.29-2.3a1 1 0 0 0-1.42 1.42l4 4Z"
        fill="inherit"
      />
    </SvgIcon>
  )
}

DownloadIcon.defaultProps = {
  sx: null,
}
